export default {
  env: "development",
  api: "/api",
  zendesk: {
    subdomain: "assetdedication1492475560",
  },
  roles: {
    ALL: ["AD Administrator", "AD Employee", "Advisor", "Advisor with HH ID", "With STRIPS", "Operations"],
    AD: ["AD Administrator", "AD Employee"],
  },
  statuses: [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
    { label: "All", value: "all" },
  ],
  permissions: {
    "account AR": ["list", "show", "edit"],
    users: [
      "list",
      "show",
      "new",
      "edit",
      "activate",
      "impersonate",
      "role",
      "unlock",
      "Section - Custodian info (AD only)",
      "Section - Access",
    ],
    companies: [
      "list",
      "show",
      "new",
      "edit",
      "activate",
      "destroy",
      "Section - Onboard",
      "Section - Partners",
      "Section - AD only",
      "user settings",
    ],
    models: [
      "list",
      "show",
      "new",
      "edit",
      "activate",
      "global",
      "edit global",
      "view global weights",
      "assign",
      "Section - Onboard",
      "Section - Partners",
      "Section - AD only",
      "download pdf",
    ],
    households: ["list", "show", "new", "edit", "view custom id", "edit custom id", "activate", "ad only", "split"],
    accounts: [
      "list",
      "show",
      "new",
      "edit",
      "activate",
      "destroy",
      "manual account",
      "new tamarac accounts",
      "convert to uc",
      "convert to admin",
      "close",
      "revert to new",
    ],
    clients: ["list", "show", "new", "edit", "activate", "delete"],
    roles: ["list", "show", "new", "edit", "activate"],
    holdings: ["list"],
    "household tickets": ["list"],
    alerts: ["list"],
    tamarac: ["list"],
    implement: ["list"],
    proposals: ["list", "show", "new", "edit", "versions"],
    settings: ["visible"],
    internal: ["visible"],
    "action button": ["visible"],
    "service teams": ["list", "new", "edit", "activate"],
    "critical-paths": [
      "list",
      "show",
      "new",
      "edit",
      "versions",
      "documents",
      "documents actions",
      "ad only",
      "monitoring",
    ],
    "billing-definitions": ["list", "new"],
    "billing-groups": ["list", "new", "billing group adjustments"],
    "automated-investing": ["list", "edit"],
    "auto-sweep": ["list", "edit"],
    "cash-reserves": ["list", "new", "delete", "edit", "show"],
    "custodial requests": ["list", "new", "edit", "paperwork admin", "activate", "destroy", "show"],
    "custodial forms": ["list", "new", "edit"],
    "tamarac uploads": ["list"],
    "model updates": ["view", "execute"],
    "proposal inventory": ["list", "edit"],
    "trading requests": ["list", "view", "edit", "modify", "purchase strips"],
    watchers: ["list", "new", "edit"],
    workers: ["new"],
    monitor: [
      "drift",
      "unassigned securities",
      "alerts",
      "add cash management",
      "drift summary",
      "drift tab",
      "edit",
      "list",
      "new",
    ],
    leads: ["new", "edit", "list"],
    trading: ["visible"],
    rebalancing: ["run"],
    "tamarac imports": ["list", "new", "edit", "unified reports"],
    "security restrictions": ["delete external account restrictions", "destroy", "edit", "list", "new", "show"],
    banners: ["list", "new", "edit"],
    "educational materials": ["list", "new", "edit", "show"],
    "adv reports": ["list", "export"],
    "income builders": ["list", "edit", "destroy", "new", "show"],
    templates: ["list", "new", "edit", "destroy", "show"],
    routes: ["list", "new", "edit"],
    reports: ["projected income view"],
    notes: ["list", "new"],
    securities: ["list", "edit", "show"],
    types: ["list"],
    zendesk: ["list"],
  },
};
